import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { FlashSaleService } from "../../../services/flash-sale-service";
import { ProductService } from "../../../services/product-service";
import Select from "react-select";
import moment from "moment";

export const Flashsaleeditcontent = (props) => {

  const { flashSaleID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState([]);

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await FlashSaleService.flashSaleUpdate(
        flashSaleID,
        values
      );

      setSubmitLoading(true);
      notify("Flash sale successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const [flashSaleInfo, setFlashSaleInfo] = useState({
    productId: "",
    actualPrice: "",
    discount_price: "",
    created_date: "",
    exp_date: "",
    flashsale_order: 0,
    status: "",
  });

  const flashSaleSearchID = async () => {
    try {
      const result = await FlashSaleService.flashSaleDetailsID(flashSaleID);
      const info = {};

      const flashSaleData = result;

      info.productId = flashSaleData.productId;
      info.actualPrice = flashSaleData.product.price;
      info.discount_price = flashSaleData.discount_price;
      info.created_date = moment(flashSaleData.created_at).format('YYYY-MM-DD');
      info.exp_date = flashSaleData.exp_date;
      info.flashsale_order = flashSaleData.flashsale_order;
      info.status = flashSaleData.status;

      setFlashSaleInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const getAllProducts = async () => {
    try {
      const result = await ProductService.allproductsNames();
      setProducts(result);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    getAllProducts();
    flashSaleSearchID();
  },[])

  const ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
  }));

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Flash Sale</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  productId: flashSaleInfo.productId,
                  actual_price: flashSaleInfo.actualPrice,
                  discount_price: flashSaleInfo.discount_price,
                  created_date: flashSaleInfo.created_date,
                  exp_date: flashSaleInfo.exp_date,
                  flashsale_order: flashSaleInfo.flashsale_order,
                  status: flashSaleInfo.status,
                }}
                validationSchema={Yup.object().shape({
                  productId: Yup.string().required("Required"),
                  discount_price: Yup.string().required("Required"),
                  exp_date: Yup.string().required("Required"),
                  status:Yup.string().required("Required"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-12 mb-3">
                        <label htmlFor="validationCustom08">Product</label>
                        <Select
                          options={ProductOptions}
                          onChange={(selectedOption)=>{
                            setFieldValue('productId', selectedOption ? selectedOption.value : "")
                            setProductId(selectedOption ? selectedOption.value : "")
                          }}
                          name="productId"
                          isClearable
                          placeholder="Filter by Product"
                          value={ProductOptions.find(option => option.value === (productId != "" ? productId : values.productId))}
                        />
                        {/* <div className="input-group">
                          <select
                            name="productId"
                            className="form-control"
                            id="productId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.productId}
                          >
                            <option value="">Select Product</option>
                            {products.map((product) => {
                              return(
                                <option key={product.id} value={product.id}>{product.name}</option>
                              )
                            })}
                          </select>
                        </div> */}
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.productId && errors.productId}
                        </div>
                      </div>
                      
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Actual Price</label>
                        <div className="input-group">
                          <input
                            name="actual_price"
                            type="number"
                            className="form-control"
                            id="priceid"
                            placeholder="Price"
                            required
                            disabled
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.actual_price}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.actual_price && errors.actual_price}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Discount Price</label>
                        <div className="input-group">
                          <input
                            name="discount_price"
                            type="number"
                            className="form-control"
                            id="priceid"
                            placeholder="Price"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.discount_price}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.discount_price && errors.discount_price}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Created Date</label>
                        <div className="input-group">
                          <input
                            name="created_date"
                            type="date"
                            className="form-control"
                            id="additionalid"
                            required
                            disabled
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.created_date}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.created_date && errors.created_date}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Expire Date</label>
                        <div className="input-group">
                          <input
                            name="exp_date"
                            type="date"
                            className="form-control"
                            id="additionalid"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.exp_date}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.exp_date && errors.exp_date}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Flash Sale Order Number</label>
                        <div className="input-group">
                          <input
                            name="flashsale_order"
                            type="number"
                            className="form-control"
                            id="flashsaleOrderId"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.flashsale_order}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.flashsale_order && errors.flashsale_order}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Status</label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="statusid"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.status}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="EXPIRED">EXPIRED</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>
                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flashsaleeditcontent;
